// Booking affiliate helpers — construct search URLs with an affiliate id when provided.
// AID is read from REACT_APP_BOOKING_AID (Booking.com partner id).
// If empty, links still work — they just don't earn commission.
const BOOKING_AID = process.env.REACT_APP_BOOKING_AID || "";
const AGODA_CID = process.env.REACT_APP_AGODA_CID || "";

export function bookingHotelUrl(cityEn) {
  const q = encodeURIComponent(cityEn);
  const base = `https://www.booking.com/searchresults.html?ss=${q}`;
  return BOOKING_AID ? `${base}&aid=${BOOKING_AID}` : base;
}

export function agodaHotelUrl(cityEn) {
  const q = encodeURIComponent(cityEn);
  const base = `https://www.agoda.com/search?city=${q}`;
  return AGODA_CID ? `${base}&cid=${AGODA_CID}` : base;
}

export function skyscannerFlightUrl(cityEn) {
  const q = encodeURIComponent(cityEn);
  return `https://www.skyscanner.com/transport/flights-to/${q.toLowerCase()}/`;
}
